import {initialWalletState, WalletInterfaceState} from '../state/wallet.state';
import {EWalletActions, WalletActions} from '../actions/wallet.actions';

export function walletReducer(state: WalletInterfaceState = initialWalletState, action: WalletActions): WalletInterfaceState {
  switch (action.type) {
    case EWalletActions.GetWalletSuccess: {
      return { ...state, wallet: action.payload };
    }

    default:
      return state;
  }
};
